(function(){
  // mobile menu
  var t=document.querySelector('.nav-toggle'), n=document.querySelector('.site-nav');
  if(t&&n){
    t.addEventListener('click',function(){ var o=n.classList.toggle('open'); t.textContent=o?'Close':'Menu'; });
    n.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){n.classList.remove('open');t.textContent='Menu';});});
  }
  // scroll reveal
  var els=document.querySelectorAll('.reveal');
  if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in');});return;}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -5% 0px'});
  els.forEach(function(e){io.observe(e);});
})();
